import { Injectable } from '@angular/core';
import { AppService, BASE_URL_CRUD } from '../app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { share } from 'rxjs/operators/share';
import { of } from 'rxjs/observable/of';

import { Currency } from '../models/currency.model';

@Injectable()
export class CurrencySettingsService extends AppService {
  private observableCache: { [communityId: number]: Observable<Currency> } = {};
  private currencyCache: { [communityId: number]: Currency } = {};

  private defaults: Currency = {
    id: null,
    value: null,
    symbol: null,
    code: null,
    decimals: null,
    separator_decimals: null,
    separator_thousands: null,
    locale_id: null,
  };

  constructor(
    http: HttpClient,
  ) {
    super(http);
  }

  public getCurrency(communityId: number): Observable<Currency> {
    if (!communityId) {
      return of(this.defaults);
    }
    if (this.currencyCache[communityId]) {
      return of(this.currencyCache[communityId]);
    } else if (this.observableCache[communityId]) {
      return this.observableCache[communityId];
    } else {
      this.observableCache[communityId] = this.getCurrencySettings(communityId);
      return this.observableCache[communityId];
    }
  }

  private getCurrencySettings(communityId: number): Observable<Currency> {
    this.endpoint = `${BASE_URL_CRUD}/configuration/community/${communityId}/CURRENCY`;
    return this.get(this.endpoint).pipe(
      map(rawData => this.mapCachedCurrency(rawData, communityId)),
      share(),
    );
  }

  private mapCachedCurrency(rawData: any, communityId: number): Currency {
    const currency = Object.assign({}, rawData);
    const parsed = JSON.parse(rawData.value);
    Object.assign(currency, parsed);
    this.observableCache[communityId] = null;
    this.currencyCache[communityId] = new Currency(currency);
    return this.currencyCache[communityId];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/currency-settings.service.ts